import { ItemList } from 'v2/models';
import {
  IFilterableField,
  EFilterFieldTypes,
  IAppliedFilter,
  EFilterOperations,
  TParamInfo,
} from '../../filters';

export const EntityOwnerField: IFilterableField = {
  displayName: 'Entity Owner',
  name: 'owner',
  type: EFilterFieldTypes.owner,
};

export const ownerFiltertoParam = (filter: IAppliedFilter) => {
  const operation = filter.operation;
  const value = filter.value as ItemList;
  const owner_ids = value?.list.map((item) => item.id).join(',');

  switch (operation) {
    case EFilterOperations.equals:
      if (value?.is_all) {
        return { [`${filter.field.name}__known`]: true };
      }
      return { [`${filter.field.name}__in`]: owner_ids };
    case EFilterOperations.notEquals:
      if (value?.is_all) {
        return { [`${filter.field.name}__known`]: false };
      }
      return { [`${filter.field.name}__not_in`]: owner_ids };
    case EFilterOperations.known:
      return { [`${filter.field.name}__known`]: true };
    case EFilterOperations.unknown:
      return { [`${filter.field.name}__known`]: false };
    default:
      return { [filter.field.name]: value };
  }
};

export const ownerParamToFilter = ({
  baseField,
  operation,
  value,
}: TParamInfo) => {
  if (baseField !== EFilterFieldTypes.owner) return;
  let filterOperation: EFilterOperations;
  let filterValue: boolean | ItemList;
  switch (operation) {
    case 'in':
      filterValue = {
        is_all: false,
        list: value.split(',').map((id) => ({ id: parseInt(id), name: '' })),
      };
      filterOperation = EFilterOperations.equals;
      break;
    case 'not_in':
      filterValue = {
        is_all: false,
        list: value.split(',').map((id) => ({ id: parseInt(id), name: '' })),
      };
      filterOperation = EFilterOperations.notEquals;
      break;
    case 'known':
      filterValue = { is_all: false, list: [] };
      if (value === 'true') filterOperation = EFilterOperations.known;
      else filterOperation = EFilterOperations.unknown;
      break;
    default:
      return;
  }
  const filter: IAppliedFilter = {
    field: EntityOwnerField,
    operation: filterOperation,
    value: filterValue,
  };
  return filter;
};
